<template>
    <div class="z-20 relative">
        <button ref="flyOutToggle" class="flex justify-between items-center bg-gray-6 w-full px-7 py-4 shadow-small z-30 relative text-sm" @click="showSummaryFlyout = !showSummaryFlyout">
            <div class="flex items-center gap-3">
                Cart summary <ChevronDown class="transition-transform" :class="{
                    'rotate-180': showSummaryFlyout
                }"/>
            </div>
            <div class="font-bold relative transition-all">
                {{ $store.getters.currencyPrefix }}{{ totalInvoiceDue }}
            </div>
        </button>
        <Transition
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
        >
            <div class="w-full absolute z-10 justify-center overflow-hidden bg-gray-5 gap-1" v-if="showSummaryFlyout" data-qa="summary-flyout">
                <SimpleSummary class="p-7 pb-0"/>
                <div class="flex justify-center p-7 pt-0">
                    <button class="text-xs font-bold leading-5 text-green-accessible underline" @click="viewFullSummary">View full summary</button>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import SimpleSummary from '@/BuyNow/Components/Summary/SimpleSummary.vue';

import ChevronDown from '@/../svg/chevron-down.svg?component';
import {priceFormat, pluralize} from '@/Util/helpers.js';

export default {
    components: {
        SimpleSummary,
        ChevronDown,
    },
    data() {
        return {
            showSummaryFlyout: false,
        };
    },
    emits: [
        'view-full-summary'
    ],
    methods: {
        priceFormat,
        beforeEnter(el) {
            el.style.height = 0;
        },
        enter(el, done) {
            el.style.height = el.scrollHeight + 'px';
        },
        leave(el) {
            el.style.height = el.scrollHeight + 'px';
            void el.offsetHeight; // force reflow
            el.style.transition = 'height 250ms ease-in-out';
            el.style.height = '0';
        },
        viewFullSummary() {
            this.$emit('view-full-summary');
            this.showSummaryFlyout = false;
        },
    },
    computed: {
        totalInvoiceDue() {
            let total = this.$store.getters.totals.total - this.$store.getters.totals.invoiceDiscountTotal.total;

            if (this.$store.getters.featureFlags?.BN_PULL_TOTALS_FROM_CB_ESTIMATE && this.$store.getters.hasFetchedEstimate) {
                total =  this.$store.getters.estimate.total / 100;
            }

            return total < 0 ? priceFormat(0) : priceFormat(total);
        },
    }
};
</script>

<style lang="postcss" scoped>
.v-enter-active,
.v-leave-active {
    transition: all 250ms ease-in-out;
}

.v-enter-from,
.v-leave-to {
}
</style>
